import { Command } from 'commander';
import { loginCommand } from './commands/login.js';
import { logoutCommand } from './commands/logout.js';
import { databasesCommand } from './commands/bases.js';
import { recordTypesCommand } from './commands/record-types.js';
import { recordsCommand } from './commands/records.js';
import { sqlCommand } from './commands/sql.js';
import { relationshipsCommand } from './commands/relationships.js';
import { relationshipTypesCommand } from './commands/relationship-types.js';
import { queryRelationshipsCommand } from './commands/query-relationships.js';
import { attachmentsCommand } from './commands/attachments.js';
import { fileTypesCommand } from './commands/file-types.js';
import { filesCommand } from './commands/files.js';
import { inboundWebhooksCommand } from './commands/inbound-webhooks.js';
import { triggersCommand } from './commands/triggers.js';
import { toolsetsCommand } from './commands/toolsets.js';
import { actionsCommand } from './commands/actions.js';
import { seedCommand } from './commands/seed.js';
import { batchCommand } from './commands/batch.js';
import { providersCommand } from './commands/providers.js';
import { tokensCommand } from './commands/tokens.js';
import { secretsCommand } from './commands/secrets.js';
import { templateCommand } from './commands/template.js';
import { adminCommand } from './commands/admin.js';
import { reportCommand } from './commands/report.js';
import { updateCommand } from './commands/update.js';
import { whoamiCommand } from './commands/whoami.js';
import { statusCommand } from './commands/status.js';
import { pullCommand } from './commands/pull.js';
import { pushCommand } from './commands/push.js';
import { useCommand } from './commands/use.js';
import { unbindCommand } from './commands/unbind.js';
import { initCommand } from './commands/init.js';
import { setCliOrgOverride } from './active-org.js';
import pkg from '../package.json' with { type: 'json' };

export const program = new Command('rekor')
  .description('Rekor CLI — System of Record for AI agents')
  .version(pkg.version)
  .option('--base <id>', 'Base ID')
  .option('--org <id>', 'Organization to operate against (overrides .rekor.yaml; ignored for rec_ tokens)')
  .option('--output <format>', 'Output format: json or table', 'table')
  .option('--json', 'Shorthand for --output json');

// Surface the global --org to the active-org resolver before any command action runs, so every
// request the command issues carries the right X-Rekor-Active-Org header.
program.hook('preAction', (thisCommand) => {
  setCliOrgOverride(thisCommand.opts()['org'] as string | undefined);
});

program.addCommand(loginCommand);
program.addCommand(logoutCommand);
program.addCommand(initCommand);
program.addCommand(whoamiCommand);
program.addCommand(statusCommand);
program.addCommand(pullCommand);
program.addCommand(pushCommand);
program.addCommand(useCommand);
program.addCommand(unbindCommand);
program.addCommand(databasesCommand);
program.addCommand(recordTypesCommand);
program.addCommand(recordsCommand);
program.addCommand(sqlCommand);
program.addCommand(relationshipsCommand);
program.addCommand(relationshipTypesCommand);
program.addCommand(queryRelationshipsCommand);
program.addCommand(attachmentsCommand);
program.addCommand(fileTypesCommand);
program.addCommand(filesCommand);
program.addCommand(inboundWebhooksCommand);
program.addCommand(triggersCommand);
program.addCommand(batchCommand);
program.addCommand(providersCommand);
program.addCommand(tokensCommand);
program.addCommand(secretsCommand);
program.addCommand(toolsetsCommand);
program.addCommand(actionsCommand);
program.addCommand(seedCommand);
program.addCommand(templateCommand);
program.addCommand(adminCommand);
program.addCommand(reportCommand);
program.addCommand(updateCommand);
